import Ajax from './base'

const Auth = {
  sendOtp: (data) => {
    const { payload, headers } = data || {}
    const route = '/v8/otp/send'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: false,
      isEncrypted: true,
      payload,
      headers,
    })
  },
  verifyOtp: (data) => {
    const { payload, headers } = data || {}
    const route = '/v8/otp/verify'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: false,
      isEncrypted: true,
      payload,
      headers,
    })
  },

  updateProfile: (data) => {
    const { payload, headers } = data || {}
    const route = '/v8/patient/update_profile'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
      headers,
    })
  },

  getPatientDetails: (payload) => {
    const route = '/v8/patient/get_patient_details'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  registerPatient: (data) => {
    const { payload, headers } = data || {}
    const route = '/v8/patient/register'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
      headers,
      priv: false,
    })
  },
  updatePatientInformation: (payload) => {
    const route = '/v8/healthcoach/update_patient_information'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      isEncrypted: false,
      content_type: 'application/json',
      payload,
    })
  },

  getUserDetails: (payload) => {
    const route = '/v8/patient/patient_details_v3'
    return Ajax.request(route, {
      method: Ajax.GET,
      priv: true,
      customToken: payload,
    })
  },

  asignGLPPlan: ({ variant, doctorId } = {}) => {
    const route = '/v8/patient/asign_GLP_plan'
    const payload = {
      variant,
      ...(doctorId && { doctorId }),
    }
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },

  saveDoctorDetails: (payload) => {
    const route = '/v8/patient/update_patient_doctor'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },
}

export default Auth
